import { RequireAtLeastOne } from '@common/types/utils/utils.interface';

export type IconSize = 'sm' | 'md' | 'lg';

export type IconContent = RequireAtLeastOne<Record<IconSize, string>>;
